/* eslint-disable import/no-anonymous-default-export */
export default {
  // 螢幕
  cp_air_snow2_screen_type: '4 英吋 IPS 螢幕',
  cp_air_snow2_screen_size: '254 ppi',
  cp_air_snow2_screen_touch: '電容式觸控螢幕',
  cp_air_snow2_screen_brightness: '亮度自動調節',
  cp_air_dany_screen_type: 'OLED 螢幕',
  cp_air_dany_screen_size: '59.9 × 49.9 毫米',
  cp_air_pheasantco2_screen_type: '低功耗段碼螢幕',
  cp_air_pheasantco2_screen_size: '61 × 49 毫米',
  cp_air_robb_screen_type: '墨水螢幕版/無螢幕版',
  cp_air_robb_screen_size: '墨水螢幕尺寸：36 × 72 毫米',

  // 可更換 PM 傳感器
  cp_air_title_pm_sensor: '可更換 PM 傳感器',
  cp_sensor_replaceable: '可更換',

  // 量程
  cp_range_label_temp: '溫度：',
  cp_range_label_humidity: '濕度：',
  cp_range_label_co2: '二氧化碳：',
  cp_range_label_pm2510: 'PM2.5/PM10：',
  cp_range_label_etvoc: 'eTVOC：',
  cp_range_label_noise: '噪音：',
  cp_range_label_light: '光照：',
  cp_range_air_not: '請勿長時間在濕度超過 90% 的環境下使用。',

  // snow2 量程
  cp_air_range_snow2_temp_value: '-10 ~ 60℃',
  cp_air_range_snow2_humidity_value: '0 ~ 99%RH（無凝露環境）',
  cp_air_range_snow2_co2_value: '400 ~ 9999 ppm',
  cp_air_range_snow2_pm2510_value: '0 ~ 999 μg/m³',
  cp_air_range_snow2_etvoc_value: 'VOC 指數 0 ~ 500，或 0.005 ~ 9.999 mg/m³',
  cp_air_range_snow2_noise_value: '36 ~ 95 dB',
  // dany 量程
  cp_air_range_dany_temp_value: '0 ~ 40℃',
  cp_air_range_dany_humidity_value: '0 ~ 95%RH（無凝露環境）',
  cp_air_range_dany_co2_value: '400 ~ 9999 ppm',
  cp_air_range_dany_pm2510_value: '0 ~ 500 μg/m³',
  // pheasant_co2 量程
  cp_air_range_pheasantco2_temp_value: '-20 ~ 50℃',
  cp_air_range_pheasantco2_humidity_value: '0 ~ 99%RH（無凝露環境）',
  cp_air_range_pheasantco2_co2_value: '400 ~ 9999 ppm',
  // robb 量程
  cp_air_mobile_range_robb_temp_value: '無螢幕版：-10 ~ 60℃，墨水螢幕版：0 ~ 50℃',
  cp_air_range_robb_temp_value: '無螢幕版：-10 ~ 60℃，',
  cp_air_range_robb_temp_value2: '墨水螢幕版：0 ~ 50℃',
  cp_air_range_robb_humidity_value: '0 ~ 99%RH（無凝露環境）',
  cp_air_range_robb_co2_value: '400 ~ 9999 ppm',
  cp_air_range_robb_pm2510_value: '0 ~ 999 μg/m³',
  cp_air_range_robb_etvoc_value: 'VOC 指數 0 ~ 500，或 0.005 ~ 9.999 mg/m³',
  cp_air_range_robb_noise_value: '36 ~ 95 dB',
  cp_air_range_robb_light_value: '0 ~ 83000 lux',

  // 尺寸重量
  cp_air_snow2_weight: '250 克',
  cp_air_snow2_size: '74 × 85 × 104 毫米',
  cp_air_dany_weight: '143 克',
  cp_air_dany_size: '63.6 × 46 × 54.6 毫米',
  cp_air_pheasantco2_weight: '129 克',
  cp_air_pheasantco2_size: '77 × 77 × 28 毫米',
  cp_air_robb_box: '主機',
  cp_air_robb_box_weight: '113 克',
  cp_air_robb_box_size: '86 × 86 × 23 毫米',
  cp_air_robb_box_power: '牆壁底盒交流電源模組/牆壁底盒低壓電源模組',
  cp_air_robb_box_power_weight: '62 克',
  cp_air_robb_box_power_size: '82 × 82 × 33 毫米',
  cp_air_robb_box_wall_power: '壁裝低壓電源模組',
  cp_air_robb_box_wall_power_weight: '57 克',
  cp_air_robb_box_wall_power_size: '86 × 86 × 24 毫米',

  // 無線通訊
  cp_air_snow2_wireless: 'Wi-Fi 2.4GHz/5GHz',
  cp_air_dany_wireless: 'Wi-Fi 2.4GHz、藍牙 5.0',
  cp_air_pheasantco2_wireless: 'Wi-Fi 2.4GHz 或 NB-IoT 或 LoRa',
  cp_air_mobile_pheasantco2_wireless: 'Wi-Fi 2.4GHz 或\nNB-IoT 或 LoRa',
  cp_air_robb_wireless: 'Wi-Fi 2.4GHz 或 NB-IoT 或 LoRa',

  // 電池
  cp_air_snow2_power_up: 'USB-C 介面供電',
  cp_air_snow2_power_up_desc: '可充電鋰電池',
  cp_air_dany_power_up: 'USB-C 介面供電',
  cp_air_dany_power_up_desc: '可充電鋰電池',
  cp_air_pheasantco2_power_up: 'USB-C 介面供電',
  cp_air_pheasantco2_power_up_desc: '可充電鋰電池',
  cp_air_robb_power_up1: '牆壁底盒交流電源模組',
  cp_air_robb_power_up_desc1: '100–240V 交流電',
  cp_air_robb_power_up2: '牆壁底盒低壓電源模組',
  cp_air_robb_power_up_desc2: '9-24V 交流電或 9–30V 直流電',
  cp_air_robb_power_up3: '青萍壁裝低壓電源模組',
  cp_air_mobile_robb_power_up_desc3: '9-24V 交流電或 9–30V 直流電或 USB-C 電源（5V⎓1A）',
  cp_air_robb_power_up_desc3: '9-24V 交流電或 9–30V 直流電或 ',
  cp_air_robb_power_up_desc4: 'USB-C 電源（5V⎓1A）',
  // mounting
  cp_air_snow2_mounting: '桌面擺放',
  cp_air_dany_mounting: '桌面擺放',
  cp_air_pheasantco2_mounting: '牆面模式',
  cp_air_robb_mounting: '牆壁安裝',

  // more features
  cp_more_features: '更多功能',
  cp_air_snow2_more_features1: '天氣預報*',
  cp_air_snow2_more_features2: '城市空氣品質（AQI）*',
  cp_air_snow2_more_features3: '紫外線指數*',
  cp_air_snow2_more_features4: '限行車牌號*',
  cp_air_snow2_more_features5: '時鐘 · 鬧鐘*',
  cp_air_snow2_more_note: '天氣預報、城市空氣品質（AQI）、紫外線指數、限行車牌號等資訊僅限部分城市提供。',
  cp_air_pheasantco2_more_features: '蜂鳴警報',
};